import {
  compose,
  withHandlers,
  lifecycle,
} from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import ContactInformation from '../../../components/ContactInformation';
import { touchField, updateField } from '../actions';

export default compose(
  withRouter,
  connect(
    (state, ownProps) => ({
      fields: state.membership.updateCustomer.get('fields').toJS(),
      firstName: ownProps.location.query.firstName,
      lastName: ownProps.location.query.lastName,
      email: ownProps.location.query.email,
      phone: ownProps.location.query.phone,
    }),
    { touchField, updateField }
  ),
  withHandlers({
    updateField: props => field => (e) => {
      const valueMap = {
        checkbox: event => event.target.checked,
        tel: value => value,
        default: event => event.target.value,
      };

      const valueFn = valueMap[field.type] || valueMap.default;
      const value = valueFn(e);

      props.updateField(field.id, value);
      props.touchField(field.id);
    },
    touchField: props => field => () => props.touchField(field.id),
    updateFieldValue: props => (fieldId, value) => {
      props.updateField(fieldId, value);
      props.touchField(fieldId);
    },
  }),
  lifecycle({
    componentDidMount() {
      ['firstName', 'lastName', 'phone', 'email']
        .forEach(field => this.props.updateFieldValue(field, this.props[field]));
    },
  })
)(ContactInformation);



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/containers/ContactInformationContainer.js